import { supabase } from "@/lib/supabase";
import { OnboardingData } from "@/types/onboarding";

interface UpdateWorkflowResult {
  success: boolean;
  message: string;
  workflowId?: string;
  updatedAt?: string;
  versionId?: string;
  error?: string;
}

/**
 * Serviço para atualizar workflows do n8n com dados do onboarding
 */
export class N8nWorkflowUpdateService {
  /**
   * Atualiza um workflow do n8n com os dados do onboarding
   * @param workflowId ID do workflow a ser atualizado
   * @param onboardingData Dados do onboarding a serem inseridos no workflow
   * @param userId ID do usuário dono do workflow
   * @returns Resultado da atualização
   */
  async updateWorkflowWithOnboardingData(
    workflowId: string,
    onboardingData: OnboardingData,
    userId: string
  ): Promise<UpdateWorkflowResult> {
    try {
      console.log('Enviando dados do onboarding para o workflow:', workflowId);
      
      // Chamar a Edge Function para atualizar o workflow
      const { data, error } = await supabase.functions.invoke('n8n-workflow-update', {
        body: {
          workflowId,
          onboardingData,
          userId
        }
      });
      
      // Verificar se houve erro
      if (error) {
        console.error('Erro ao atualizar workflow:', error);
        return {
          success: false,
          message: `Erro ao atualizar workflow: ${error.message}`,
          error: error.message
        };
      }
      
      // Verificar se os dados foram retornados
      if (!data) {
        console.error('Erro: Nenhum dado retornado da função');
        return {
          success: false,
          message: 'Erro: Nenhum dado retornado da função',
          error: 'Nenhum dado retornado'
        };
      }
      
      // Verificar se houve erro na resposta da Edge Function
      if (data.error) {
        console.error('Erro retornado da Edge Function:', data.error);
        return {
          success: false,
          message: data.message || 'Erro ao atualizar workflow',
          error: data.error
        };
      }
      
      // Retornar sucesso
      return {
        success: true,
        message: data.message || 'Workflow atualizado com sucesso',
        workflowId: data.workflowId,
        updatedAt: data.updatedAt,
        versionId: data.versionId
      };
    } catch (error) {
      console.error('Erro ao atualizar workflow:', error);
      return {
        success: false,
        message: `Erro ao atualizar workflow: ${error.message}`,
        error: error.message
      };
    }
  }
}

// Exportar instância singleton do serviço
export const n8nWorkflowUpdateService = new N8nWorkflowUpdateService(); 